<template>
  <div class="alipay" v-if="isWeixin"></div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { Indicator, MessageBox } from 'mint-ui'

  export default {
    data () {
      return {
        isWeixin: false,
        query: {},
        timer: ''
      }
    },
    created () {
      // document.title = '支付宝支付'
      let _href = window.location.href
      if (_href.indexOf('&replace=1') <= -1) {
        window.location.replace(_href + '&replace=1')
      }
      this.query = this.$route.query
      this.isWeixin = this.$utils.isWeiXin()

      if (!this.$utils.isWeiXin()) { // 判断是否微信浏览器中打开
        this.$indicator.open({
          text: '正在跳转...',
          spinnerType: 'fading-circle'
        })
        let p = new Promise(this.getOrderDetail)
        p.then((data) => {
          if (data.order_status > 1000) {
            this.$indicator.close()
            _this.$router.replace({name: 'PaySuccess1', query: {orderId: this.query.oid}})
            // 支付完成
            // this.$messagebox.alert('您已经成功付款', '支付完成')
            // MessageBox({
            //   title: '支付完成',
            //   message: '您已经成功付款',
            //   confirmButtonText: '确认'
            // })
          } else {
            this.aliPay()
          }
        })
      } else {
        this.timer = setInterval(this.refreshOrder, 3000)
      }
    },
    methods: {
      refreshOrder () {
        var _this = this
        var param = {
          token: this.query.t,
          order_id: this.query.oid
        }
        actions.getOrderDetail(_this, param, (data) => {
          if (data.order_status > 1000) {
            clearInterval(this.timer)
            // 支付完成
            // MessageBox({
            //   title: '支付完成',
            //   message: '您已经成功付款',
            //   confirmButtonText: '确认'
            // }).then(action => {
            //   this.$router.push({name: 'OrderDetail'})
            // })
            _this.$router.replace({name: 'PaySuccess1', query: {orderId: _this.query.oid}})
            // this.$messagebox.confirm('您已经成功付款', '支付完成').then(action => {
            //   // localStorage.setItem('paySource','alipay')
            //   this.$router.push({name: 'OrderDetail'})
            // })
          }
        })
      },
      getOrderDetail (resolve, reject) {
        // 查询订单状态
        var _this = this
        var param = {
          token: this.query.t,
          order_id: this.query.oid
        }
        actions.getOrderDetail(_this, param, (data) => {
          resolve(data)
        })
      },
      aliPay () {
        var _this = this
        var params = {
          token: this.query.t,
          order_id: this.query.oid,
          payType: 52
        }
        params.returnUrl = encodeURIComponent(this.$utils.getHost() + `/alipay?oid=${this.query.oid}&t=${this.query.t}`)
        actions.postWxJsPay(_this, params, (data) => {
          _this.$indicator.close()
          const div = document.createElement('div')
          div.innerHTML = data.body
          document.body.appendChild(div)
          document.forms[0].submit()
        }, (response) => {
          // 响应错误回调
          if (response.data.message) {
            // MessageBox.alert(response.data.message, '')
            this.$messagebox.alert(response.data.message, '')
          }
        })
      }
    }
  }
</script>
<style>
  .alipay{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-image: url("../assets/images/pinbi.jpg");
    background-repeat: no-repeat;
    background-size: 90% auto;
    background-position: center top;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// AliPay.vue?2c9a2b1a